// src/com/auto_dida_info/AutoDidaInfoDict.js
import { AppObject, InputType, TableColumnType } from "../../value/AppConst";
import IsValid from "../../value/IsValid";

const Dict = {
    // toAdd, toEdit : mark if need to submit for mutation
    dcCd : {
		id: 'dcCd', label: '물류센터',
		type: InputType.select, required: true, toAdd: true, toEdit: true,
	}, // varchar(3)
    storeId : {
		id: 'storeId', label: '점포',
		type: InputType.select, required: true, toAdd: true, toEdit: true,
        labelKey: 'storeName', 
	}, // varchar(10)
    didaDate : {
		id: 'didaDate', label: '점포 휴무일',
		type: InputType.text, required: true, toAdd: true, toEdit: true,
	}, // date
    oldDidaDate : {
        id: 'oldDidaDate', label: '기존 휴무일',
        type: InputType.text, required: true, toAdd: false, toEdit: true,
    },
    weekDay : {
		id: 'weekDay', label: '요일',
	}, // tinyint(4)
    dcName : {
		id: 'dcName', label: '물류센터',
	}, // varchar(20)
    storeName : {
		id: 'storeName', label: '점포',
	}, // varchar(30)
    
};

function printWeekDay(v) {
    if(v===0) return <span style={{color:'#999'}}>일요일</span>;
    return AppObject.weekChars[v%7]+'요일';
}

function printIfOk(v) {
    if(v) return 'OK';
    return <span style={{color:'red'}}>오류</span>;
}

/**
 * AUTO_DIDA_INFO React Component Dictionary for Input and Output
 * Project: NewTOP for cloud
 * 2024-10-18 13:21:05 using DbdbTap
 */
export const AutoDidaInfoDictionary = {
    inputMap: Dict,
    errorTitle: {
        Add: '점포별 휴무일 등록 오류',
        Edit: '점포별 휴무일 수정 오류',
        Remove: '점포별 휴무일 삭제 오류',
        Get: '점포별 휴무일 조회 오류',
    },
    tableProps: {
        tableId: 'autoDidaInfoTable',
        uniqueKey: 'dcCd_storeId_didaDate',
        flexOption: {
            multiChecker:false,
            hideFirstTopButton: false,
            hideColumnConfig: true,
            hideBubble: false,
            growToFill: true,
        },
        columns: [
            //print using getTableColumnOption(c,t,i)
            //{ id: 'dcCd', label: Dict.dcCd.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            //{ id: 'storeId', label: Dict.storeId.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'dcName', label: Dict.dcName.label, width: 100, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'storeName', label: Dict.storeName.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'didaDate', label: Dict.didaDate.label, width: 100, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            { id: 'weekDay', label: Dict.weekDay.label, width: 60, show: true, option:{align: 'center', print:(r,i,v)=>printWeekDay(v)} },
            { id: 'regDate', label: "등록일", width: 130, show: true, option:{align: 'center', print:(r,i,v)=>v?v.substring(0,16):'-'} },
            { id: 'regUserName', label: "등록자", width: 80, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
        ]
    },
    uploadTableProps: {
        tableId: 'autoDidaInfoUploadTable',
        uniqueKey: 'key',
        flexOption: {
            multiChecker:false,
            hideFirstTopButton: true,
            hideColumnConfig: true,
            hideBubble: true,
            growToFill: true,
        },
        columns: [
            { id: 'ok', label: '상태', width: 50, show: true, option:{align: 'center', print:(r,i,v)=>printIfOk(v)} },
            { id: 'dcCd', label: 'DC코드', width: 70, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            { id: 'storeId', label: '점포코드', width: 90, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            { id: 'didaDate', label: Dict.didaDate.label, width: 90, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
        ]
    }
};
